import { makeGenericToken } from './util.make-generic-token.js';

function makeScalarToken(propName, input) {
  const realDefaultValue = (() => {
    if (typeof input === "function" && "defaultValue" in input) {
      return input.defaultValue;
    }
    if (typeof input === "function") {
      return input();
    }
    return input;
  })();
  const appliedDefaultValue = (() => {
    if (typeof input === "function") {
      return input();
    }
    return input;
  })();
  return makeGenericToken(function format() {
    return `var(${propName}, ${appliedDefaultValue})`;
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    return {
      [propName]: typeof nextValue === "function" ? nextValue() : String(nextValue)
    };
  }, function extend(propName, token) {
    return makeScalarToken(propName, token);
  }, {
    propName,
    defaultValue: realDefaultValue
  });
}

export { makeScalarToken };
//# sourceMappingURL=token.scalar.js.map
